module.exports = __webpack_public_path__ + "img/cert-zhuxiao.44ff0a88.svg";